import { render, staticRenderFns } from "./ErrorNotFound.vue?vue&type=template&id=02bac966&"
import script from "./ErrorNotFound.vue?vue&type=script&lang=js&"
export * from "./ErrorNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02bac966')) {
      api.createRecord('02bac966', component.options)
    } else {
      api.reload('02bac966', component.options)
    }
    module.hot.accept("./ErrorNotFound.vue?vue&type=template&id=02bac966&", function () {
      api.rerender('02bac966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ErrorNotFound.vue"
export default component.exports